// removed by extract-text-webpack-plugin
module.exports = {"price":"_2qZw0"};